import { render, staticRenderFns } from "./NodeMemoriesList.vue?vue&type=template&id=ede77b5c&lang=pug&"
import script from "./NodeMemoriesList.vue?vue&type=script&lang=js&"
export * from "./NodeMemoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ede77b5c')) {
      api.createRecord('ede77b5c', component.options)
    } else {
      api.reload('ede77b5c', component.options)
    }
    module.hot.accept("./NodeMemoriesList.vue?vue&type=template&id=ede77b5c&lang=pug&", function () {
      api.rerender('ede77b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/widget/NodeMemoriesList.vue"
export default component.exports